export default __webpack_public_path__ + "static/media/horizontal6.fd7eb196.JPG";